import request from '../request'
import store from '../../store'

// 仪表盘-鉴定数据统计列表（完成/受理情况） (中间顶部数据)
export function getJDStatisticsList(params) {
  return request.get("/largescreen/appraise/getJDStatisticsList", {...params, areaId : store.getters.getactiveRegionObj.areaCode}).then((res) => res);
}

// 鉴定能力列表
export function getAppraiseOutlineList(params) {
  return request.get("/largescreen/appraise/getAppraiseOutlineList", {...params, areaId : store.getters.getactiveRegionObj.areaCode}).then((res) => res);
}

// 检验检测资质
export function getAptitudeList(params) {
  return request.get("/largescreen/appraise/getAptitudeList", {...params, areaId : store.getters.getactiveRegionObj.areaCode}).then((res) => res);
}

// 各农机企业鉴定数量
export function getEnterpriseAppraiseList(params) {
  return request.get("/largescreen/appraise/getEnterpriseAppraiseList", {...params, areaId : store.getters.getactiveRegionObj.areaCode}).then((res) => res);
}

// 国家支持的推广鉴定信息
export function getCountrySupportList(params) {
  return request.get("/largescreen/appraise/getCountrySupportList", {...params, areaId : store.getters.getactiveRegionObj.areaCode}).then((res) => res);
}

// 申请省级鉴定企业及产品
export function getEnterpriseProductList(params) {
  return request.get("/largescreen/appraise/getEnterpriseProductList", {...params, areaId : store.getters.getactiveRegionObj.areaCode}).then((res) => res);
}

// 省份列表（地图）
export function getAppraiseProvinceList(params) {
  return request.get("/largescreen/appraise/getAppraiseProvinceList", {...params, areaId : store.getters.getactiveRegionObj.areaCode}).then((res) => res);
}